export default __webpack_public_path__ + "static/media/27t.bda93256.jpg";